import i18n from '@/i18n'
import {mapActions, mapGetters} from 'vuex'
import {EventHub} from '@/constants/constants'
import {DialogHarvest} from "@/tools/dialog"
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
    name: 'HarvestDialogComponent',
    components: {
        DatePicker
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        // model del formulario
        validForm: false,
        // reglas de validación
        validationRules: {
            required: (value) => !!value || `${i18n.t('required')}`,
            positiveIntNumber: (v) => /^[1-9]\d*$/.test(v) || `${i18n.t('onlypositiveIntegers')}`,
        },
        // errores para el campo del núm de línea
        dateError: [],
        nameError: [],
        menu: false,
        timePickerDisabled: false,
        datePickerDisabled: false,
        resultdate: '',
        time: null,
        date: '',
        tonsPerHour: null,
        speedPorcentageValue: null
    }),
    computed: {
        ...mapGetters({
            'getBread': 'breadcrumbs/getBread',
        }),

    },
    created() {
        /**
         * El modelo de datos del diálogo se carga a través del objeto del breadcrumb
         */
        this.unwatch = this.$store.watch(
            (state, getters) => getters['breadcrumbs/getBread'],
            (newBreads) => {
                const lastBreadcrumb = this.getBread[newBreads.length - 1]
                if (!lastBreadcrumb) {
                    this.cancel()
                } else {
                    if (lastBreadcrumb.key === DialogHarvest) {
                        if (lastBreadcrumb.model) {
                            const modelData = this.model
                            Object.assign(modelData, lastBreadcrumb.model)
                        }
                    }
                }
            },
            { /*deep: true*/})

        this.$eventBus.$on('initFields', (model) => {
            if (model.update) {
                let newDate = moment(model.date).format("yyyy-MM-DD")
                const hour = moment(model.date).format('HH');
                this.time = moment(`2000-01-01T${hour}:00`, 'YYYY-MM-DDTHH:mm').toDate();
                this.date = newDate;
                this.tonsPerHour = model.tonsPerHour;
                this.speedPorcentageValue = model.speedPorcentageValue
                if (model.state === 'active') {
                    this.datePickerDisabled = true;
                    this.timePickerDisabled = true
                }
            } else {
                this.date = ''
                this.time = null
                this.datePickerDisabled = false;
                this.timePickerDisabled = false
            }
        })
    },
    async mounted() {

        /**
         * El modelo de datos del diálogo se carga a través del objeto del breadcrumb
         */
        const lastBreadcrumb = this.getBread[this.getBread.length - 1]
        if (!lastBreadcrumb) {
            this.cancel()
        } else {
            if (lastBreadcrumb.key === DialogHarvest) {
                if (lastBreadcrumb.model) {
                    const modelData = this.model
                    Object.assign(modelData, lastBreadcrumb.model)
                }
            }
        }

        if (this.model.update) {
            let newDate = moment(this.model.date).format("yyyy-MM-DD")
            const hour = moment(this.model.date).format('HH');
            this.time = moment(`2000-01-01T${hour}:00`, 'YYYY-MM-DDTHH:mm').toDate();
            this.date = newDate;
            this.tonsPerHour = this.model.tonsPerHour
            this.speedPorcentageValue = this.model.speedPorcentageValue
            if (this.model.state === 'active') {
                this.datePickerDisabled = true;
                this.timePickerDisabled = true
                this.resultdate = new Date(this.model.date)
            } else {
                this.isHarvestDateValid(this.date)
            }
        } else {
            this.date = ''
            this.time = null
            this.datePickerDisabled = false;
            this.timePickerDisabled = false
        }

    },

    beforeDestroy() {
        // elimino la instancia del watcher del breadcrumb
        this.unwatch()
    },
    methods: {

        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            if (this.$refs.form) {
                this.$refs.form.reset()
            }
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.dateError = []
            this.nameError = []
            this.pullBread(DialogHarvest)
            this.model.name = undefined
            this.model.date = undefined
            this.model.state = undefined

        },
        handleDateChange(date) {
            this.timePickerDisabled = false;
            if (!date) return
            this.isHarvestDateValid(date)
        },
        handleHourChange(time) {
            this.model.date = this.date;
            this.time = time;
            this.handleDateChange(this.model.date);
        },
        handleNameChange(name) {
            if (!name) return
            this.isNameRepeated(name)
        },
        /**
         * Guardar
         */
        save() {
            const harvestDto = this.getHarvesterDto()

            if (this.model.update) {
                this.$eventBus.$emit(EventHub.UPDATE_HARVEST, harvestDto)
            } else {

                this.$eventBus.$emit(EventHub.COMMIT_HARVEST, harvestDto)
            }
            this.cancel()
        },
        isNameRepeated(name) {
            const harvests = [...this.model.harvests]
            if (harvests.some(harvest => harvest.name.localeCompare(name, undefined, {sensitivity: 'base'}) === 0)) {
                this.nameError.push(`${i18n.t('harvest.error.nameRepeated')}`)
            } else {
                this.nameError = []
            }
        },
        /**
         * Valida que la fecha de la nueva cosecha tengo una distancia de al menos 90 dias con respecto a las cosechas existentes
         * @param {*} newDate
         * @returns
         */
        isHarvestDateValid(newDate) {
            if (this)
                this.dateError = []
            const objDate = new Date(newDate + 'T00:00:00')

            if (this.time) {
                let hours = new Date(this.time).getHours()
                objDate.setHours(hours)
                objDate.setMinutes(0);
                objDate.setSeconds(0);
            }

            const formattedDate = moment(objDate).format('yyyy-MM-DDThh:mm')

            if (formattedDate === this.model?.oldDate) return true

            let harversts = this.model?.harvests

            // si es una actualizacion de una cosecha, se filtran la cosecha que tenga la misma fecha que la cosecha que se esta actualizando
            if (this.model?.oldDate) {
                harversts = harversts.filter(harvest => moment(new Date(harvest.date * 1000)).format('yyyy-MM-DDTHH:mm') !== this.model?.oldDate)
            }

            // const today = moment(new Date())
            const tomorrow = moment().add(1, 'day').startOf('day')
            const harvestsDates = harversts?.map(harvest => moment(new Date(harvest.date * 1000)))
            const newHarvestDate = moment(/*new Date(newDate)*/objDate)
            // si selecciona una fecha anterior a la fecha actual, se muestra un error
            if (newHarvestDate.isBefore(tomorrow)) {
                this.dateError.push(`${i18n.t('harvest.error.dateIsBeforeToday')}`)
                return false
            }
            // compares each harvestsDates with the newHarvestDate to check if they have a distance of 90 days or less
            if (harvestsDates?.length > 0) {
                for (let i = 0; i < harvestsDates.length; i++) {
                    const diff = harvestsDates[i].diff(newHarvestDate, 'days', true)
                    if (diff < 90 && diff > -90) {
                        this.dateError.push(`${i18n.t('harvest.error.dateLessThan90Days')}`)
                        return false
                    }
                }
            }
            this.resultdate = objDate
            return true
        },
        /**
         * Genera el DTO para actualizar / crear una ranja
         */
        getHarvesterDto() {
            return {
                name: this.model.name,
                date: this.resultdate.getTime() / 1000,
                state: this.model.state ?? 'inactive',
                oldDate: new Date(this.model.oldDate).getTime() / 1000,
                tonsPerHour: this.tonsPerHour ? this.tonsPerHour : 80,
                speedPorcentageValue: this.speedPorcentageValue ? this.speedPorcentageValue : 10
            }
        },
    },
    watch: {
        model: {
            //deep: true,
            //immediate: true,
            handler(newVal) {
                this.$emit('initfields', newVal)
            }
        },
    }
}
